import { render } from "./NewRoute.vue?vue&type=template&id=796586ce&scoped=true"
import script from "./NewRoute.vue?vue&type=script&lang=js"
export * from "./NewRoute.vue?vue&type=script&lang=js"

import "./NewRoute.vue?vue&type=style&index=0&id=796586ce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796586ce"]])

export default __exports__